import script from "./CadastroLeito.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroLeito.vue?vue&type=script&setup=true&lang=js"

import "./CadastroLeito.vue?vue&type=style&index=0&id=c347e42a&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c347e42a"]])

export default __exports__